module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAiCAYAAAA3WXuFAAAAAXNSR0IArs4c6QAAAExJREFUWEft0rERADAIxDDYf2lGUEvhtN9wineevX12z3SQfiShhCSgvYYSkoD2GkpIAtprKCEJaK+hhCSgvYYSkoD2GkpIAtprSEIHZFQAI8KvUjIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/icon-favorite-active.png
// module id = YIj2
// module chunks = 96